module.exports = __webpack_public_path__ + "static/media/Results-11.ed2eabcf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proof/Results-11.jpg
// module id = 364
// module chunks = 0